<template>
  <div>
    <b>General description</b>
    <br />
    This mission allows to simulate different phases of the spacecraft's
    mission, from post-injection positioning to deorbitation.
    <br />
    The atmosphere model considered is the tabulated US76, which is used to
    compute the atmospheric density between 0 and 1000 km. If the drag
    perturbation is enabled it will affect all the submissions but the orbit
    phasing ones. Drag is always taken into account for LEO Station Keeping missions.
    <br />
  </div>
</template>

<script>
export default {
  name: 'tooltipParametricSequenceOfMissions'
}
</script>
